import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Keyboard, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch, useSelector } from "react-redux";
import { getCompanies } from "../../reduxToolkit/features/adminPanel/medicine";
import LoadingBox from "../misc/Loading";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { PF } from "../../config";
import { colors, fonts, radii, shadows } from "../../theme/designTokens";

export default function Brands() {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  // use state
  const [loadingMain, setLoadingMain] = useState(false);
  const [lang, setLang] = useState("en");
  const [companyList, setCompanyList] = useState([]);

  // store
  const { companies } = useSelector((state) => state.medicine);
  const { activeLangFront } = useSelector((state) => state.miscFront);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!(companies && companies.length > 0)) dispatch(getCompanies());
    // dispatch(getDosages());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Set Language
  useEffect(() => {
    if (activeLangFront) {
      setLang(activeLangFront.langCode);
    }
  }, [activeLangFront]);

  // set Companies
  useEffect(() => {
    if (lang !== "" && companies && companies.length > 0) {
      setLoadingMain(true);
      let C = companies.find((c) => c.lang === lang);
      if (C && C.data) setCompanyList(C.data.filter((d) => d.isVisible));
      else setCompanyList([]);
      if (companies) {
        setTimeout(() => {
          setLoadingMain(false);
        }, 1000);
      }
    }
  }, [companies, lang]);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  return (
    <>
      {loadingMain ? (
        <LoadingBox w={"100%"} h={"200px"} />
      ) : (
        <Box sx={{ py: { xs: 4, md: 6 } }}>
          <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 } }}>
            <Typography
              align="center"
              sx={{
                fontFamily: fonts.display,
                fontWeight: 800,
                fontSize: "1.3rem",
                color: colors.ink2,
                mb: 3.5,
              }}
            >
              {translateFront("Our Partners")}
            </Typography>
            <Swiper
              slidesPerView={!smUp ? 1 : !mdUp ? 2 : 6}
              grabCursor
              modules={[Keyboard, Autoplay]}
              spaceBetween={16}
              className="deal"
              loop={{ loop: true }}
              autoplay={{ delay: 3000 }}
            >
              {companyList.map((x, i) => (
                <SwiperSlide key={i}>
                  <Box
                    sx={{
                      borderRadius: radii.md,
                      border: `1px solid ${colors.line}`,
                      boxShadow: shadows.card,
                      bgcolor: colors.white,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: 120,
                        bgcolor: colors.white,
                      }}
                    >
                      <LazyLoadImage
                        effect="blur"
                        src={
                          x.companyLogo.includes("http")
                            ? x.companyLogo
                            : PF + "adminPanel/companies/" + x.companyLogo
                        }
                        alt={x.companyName}
                        title={x.companyName}
                        style={{
                          width: "90px",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                    <Box sx={{ p: 1.25, bgcolor: colors.paperTint }}>
                      <Typography
                        align="center"
                        sx={{ fontSize: 13, fontWeight: 600, color: colors.ink2 }}
                      >
                        {x.companyName}
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </Box>
      )}
    </>
  );
}
